import { render, staticRenderFns } from "./hero-simple.vue?vue&type=template&id=3eca5f99"
import script from "./hero-simple.vue?vue&type=script&lang=js"
export * from "./hero-simple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports